import React from 'react';

import { useAtomValue } from 'jotai';

import { Banner, Video } from '@features/phone-subscription';
import { getAssetType } from '@shared/utils/get-asset-type';
import { languageAtom } from '@shared/store/slice-atoms';

const BannerTop = ({ bannerConfig }) => {
  const language = useAtomValue(languageAtom);
  const currentBanner = bannerConfig?.[language.locale] || bannerConfig?.['en'];
  const assetType = getAssetType(currentBanner);

  if (currentBanner) {
    if (assetType === 'video' && bannerConfig?.isVideo) {
      return <Video bannerConfing={bannerConfig} />;
    }

    if (assetType === 'image' && bannerConfig?.isImage) {
      return <Banner bannerConfig={bannerConfig} />;
    }
  }

  return <Video />;
};

export { BannerTop };
